import { httpApi } from '@app/api/http.api'

export interface InspectionRequest {
  deviceId: string
  companyName: string
  inspectionDate: string
  inspectionType: string
  validityDate: string
  warningDays: number
  inspectorId?: string
  pdfRaport?: {
    content: string
    name: string
    type: string
  }
}

export interface InspectionResponse {
  id: string
  deviceId?: string
  companyName: string
  inspectionDate: string
  inspectionType: string
  validityDate: string
  inspector: {
    firstName: string
    lastName: string
  }
  device: {
    name: string
    serialNumber: string
    id: string
    udtNumber: string
  }
  pdfRaport?: JSON
  warningDays: number
  isChecked: boolean
}
type FilterDataProps = {
  fromDate: string
  toDate: string
}

export const createInspection = (inspectionPayload: InspectionRequest): Promise<InspectionResponse> =>
  httpApi.post<InspectionResponse>(`inspections/create-inspection`, { ...inspectionPayload }).then(({ data }) => data)

export const getInspectionsList = (payload: {
  deviceId: string
  fromDate: string
  toDate: string
}): Promise<InspectionResponse[]> =>
  httpApi.post<InspectionResponse[]>(`inspections/list`, payload).then(({ data }) => data)

export const deleteInspection = (inspectionId: string): Promise<void> =>
  httpApi.delete<void>(`inspections/${inspectionId}`).then(({ data }) => data)

export const updateInspection = (inspectionId: string, confirmedByUserId: string): Promise<InspectionResponse> =>
  httpApi
    .patch<InspectionResponse>(`inspections/update-inspection/${inspectionId}`, { confirmedByUserId })
    .then(({ data }) => data)
